import { TypeOfValueAddition4Dto  } from "@gtpl/shared-models/masters";
import { GlobalResponseObject } from '@gtpl/shared-models/common-models';


export class AllTypeOfValueAddition4ResponseModel extends GlobalResponseObject {
    data?: TypeOfValueAddition4Dto[];

    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data /TypeOfValueAddition4Dto[]
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: TypeOfValueAddition4Dto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}

